import type { TelemetryBreadcrumb, TelemetryEvent } from "./types.js";
import { isLogEventKind } from "./types.js";

export function eventToBreadcrumb(event: TelemetryEvent): TelemetryBreadcrumb | null {
  if (!isLogEventKind(event.kind) || !event.message) return null;

  return {
    timestamp: event.timestamp,
    category:
      typeof event.attributes?.category === "string"
        ? event.attributes.category
        : event.kind,
    message: event.message,
    level: event.level,
    data: event.attributes,
  };
}

export class BreadcrumbBuffer {
  private readonly maxSize: number;
  private readonly entries: TelemetryBreadcrumb[] = [];

  constructor(maxSize = 50) {
    this.maxSize = Math.max(1, maxSize);
  }

  push(entry: TelemetryBreadcrumb): void {
    this.entries.push(entry);
    while (this.entries.length > this.maxSize) {
      this.entries.shift();
    }
  }

  pushFromEvent(event: TelemetryEvent): void {
    const crumb = eventToBreadcrumb(event);
    if (crumb) this.push(crumb);
  }

  snapshot(): TelemetryBreadcrumb[] {
    return [...this.entries];
  }

  clear(): void {
    this.entries.length = 0;
  }
}
